<template>
    <div class="book-tags" style="display: ruby;">
        <div style="margin: 2px;font-size: 13px;"
            v-for="tag in tags" 
            :key="tag" 
            class="tag"
        >
            {{ tag }}
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BookTags',
    props: {
      tags: {
        type: Array,
        default: () => []
      }
    }
  }
  </script>